export default __webpack_public_path__ + "images/5f959cd01e25ff021a2843ac5449a90e-check-bundle-item.svg";